export default {
  CreateSettlementTitle: 'Choose a sponsor',
  createSettlementDescription: 'To continue, choose one of the following options',
  coverageSelection: 'Coverage',
  coverageSelectionDescription: 'Choose one of the following options',
  cutoffTitle: 'Cut-off range',
  cutoffDescription: 'Chose a date range',
  error: 'An error occurred when creating the settlement',
  steper: { 
    sponsorSelection: "Sponsor selection",
    authorizations: "Authorizations"
  },
  buttons: {
    next: "Next",
    back: "Back",
    cancel: "Cancel",
    end: "Finish",
    changeSponsor: "Change"
  },
  title: {
    text: 'New settlement',
    back: 'Cancel'
  },
  dates: {
    init: "From",
    final: "To"
  },
  authorizations: {
    cutoffRange: "Cut-off range",
    totalResults: "{total} results",
    selectedRows: "{selected} selected",
    chooseTitle: "Choose the authorizations you want to add to the settlement",
    chooseDescription: "You can unselect authorizations",
    selectAll: "Select all",
    grid: {
      id: "Authorization ID",
      createdAt: "Created At",
      beneficiaryName: "Beneficiary",
      memberCode: "Member code",
      coverage: "Coverage"
    },
    manualAuthorizations: {
      select: "Include manual authorizations",
      label: "Manual authorizations",
      quantity: "quantity",
      amount: "amount",
      errors: {
        quantityAndAmountRequired: "You must enter the quantity and amount for manual authorizations",
        quantityAndAmountPositive: "The quantity and amount must be greater than 0"
      }
    },
  },
    billing: {
    title: 'Complete settlement',
    subtitle: 'Enter the following information',
    quantitySubtitle: 'No Authorizations to be settled | 1 Authorization to be settled | {n} Authorizations to be settled',
    complete: "Complete",
    invoiceNumber: {
      label: 'Invoice number',
      placeholder: 'Invoice number'
    },
    invoiceDate: {
      label: 'Invoice date',
      placeholder: 'Invoice date'
    },
    invoiceAmount: {
      label: 'Invoice amount',
      placeholder: 'Invoice amount'
    },
    taxReceiptNumber: {
      label: 'NCF',
      placeholder: 'NCF'
    },
    taxReceiptNumberDate: {
      label: 'NCF date',
      placeholder: 'NCF date'
    },
    taxReceiptNumberExpirationDate: {
      label: 'NCF expiration date',
      placeholder: 'NCF expiration date'
    },
    invoiceFile: {
      label: 'Invoice document',
      placeholder: 'Drag and drop or',
      placeholderDrag: "Drag and drop",
      upload: "Upload file",
      replace: "Replace"
    },
    creditNoteFile: {
      label: 'Credit note file (optional)',
      placeholder: 'Drag and drop or',
      upload: "Upload file",
      placeholderDrag: "Drag and drop",
      replace: "Replace"
    },
    debitNoteFile: {
      label: 'Debit note file (optional)',
      placeholder: 'Drag and drop or',
      upload: "Upload file",
      placeholderDrag: "Drag and drop",
      replace: "Replace"
    },
    errors: {
      multipleFileUpload: "Only one file can be uploaded at a time",
      fileTypeIncorrect: "File extension incorrect"
    }
  }
}